import { ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const testNameStyles = xcss({
  color: 'color.text.accent.gray',
  font: token('font.body.UNSAFE_small'),
  paddingBlock: 'space.025',
  paddingInlineEnd: 'space.500',
  display: 'flex',
  alignItems: 'center',
  gap: 'space.075',
});

const childWrapperStyles = xcss({
  maxWidth: '300px',
  display: 'flex',
  alignItems: 'center',
  gap: 'space.025',
});

const textWrapperStyles = xcss({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const childSuitNameWrapperStyles = xcss({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  maxWidth: '100%',
});

const testSuiteNameStyles = xcss({
  color: 'color.text.accent.gray',
  font: token('font.body.UNSAFE_small'),
  paddingBlock: 'space.025',
  paddingInlineEnd: 'space.500',
  display: 'flex',
  alignItems: 'center',
  gap: 'space.075',
});

type Props = {
  children: ReactNode;
};

export const TestName = ({ children }: Props) => (
  <Box xcss={testNameStyles}>{children}</Box>
);

export const TestChildWrapper = ({ children }: Props) => (
  <Box xcss={childWrapperStyles}>{children}</Box>
);

export const TestTextWrapper = ({ children }: Props) => (
  <Box xcss={textWrapperStyles}>{children}</Box>
);

export const TestSuitNameWrapper = ({ children }: Props) => (
  <Box xcss={childSuitNameWrapperStyles}>{children}</Box>
);

export const TestSuiteName = ({ children }: Props) => (
  <Box xcss={testSuiteNameStyles}>{children}</Box>
);
